import React, { Component } from 'react'
import cn from 'classnames'
import { Button, Input, Form, InputNumber, message, Tag, AutoComplete } from 'antd'
import styles from './style.module.less'

@Form.create()
class AddPriceForm extends Component {
  handleSubmit = e => {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.onSubmit(values)
        this.props.form.resetFields()
        // message.info('已添加，请记得保存!')
      }
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form

    return (
      <Form onSubmit={this.handleSubmit}>
        <div className={styles.addForm}>
          <Form.Item
            className={styles.cell}
            required>
            {getFieldDecorator('name', {
              rules: [
                {
                  required: true,
                  message: '请输入费用名称',
                },
              ],
            })(
              <AutoComplete
                autoFocus
                dataSource={[
                  '安装费',
                  '维修费',
                  '路费',
                  '搬运费',
                  '快递费',
                  '配件费',
                  '上门费',
                  '运输费',
                  '安新拆旧/多台'
                ]}
                placeholder="请输入费用名称" />
            )}
          </Form.Item>
          <Form.Item className={styles.cell} required>
            {getFieldDecorator('price', {
              rules: [
                {
                  required: true,
                  message: '请输入费用',
                },
              ],
            })(
              <InputNumber
                className={styles.priceInput}
                placeholder="请输入费用"
                min={0} />
            )}
          </Form.Item>
          <Form.Item className={styles.cell}>
            <Button htmlType="submit" type="primary">添加</Button>
          </Form.Item>
        </div>
      </Form>
    )
  }
}

export default AddPriceForm
